// @ts-nocheck

import React from 'react';
import type { Node } from 'react';
import styled, { css } from 'styled-components';

import { CheckmarkStroke } from '../../assets/svg/common';

export type CheckboxThemeType = {
  checkboxBorderColor: string;
  checkmarkColor: string;
};

const defaultTheme: CheckboxThemeType = {
  checkboxBorderColor: '#606467',
  checkmarkColor: '#ffffff',
};

type StyledComponentPassedProps = { $theme: CheckboxThemeType; $checked?: boolean };

const ANIMATION_DURATION = 300;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: white;
  cursor: pointer;

  ${({ $isDisabled }) =>
    $isDisabled
      ? css`
          opacity: 0.5;
          pointer-events: none;
        `
      : undefined};
`;

const StyledCheckbox = styled.div`
  position: relative;
  height: 1em;
  width: 1em;
  background: transparent;
  border: ${({ $theme }: StyledComponentPassedProps) => `1px solid ${$theme.checkboxBorderColor}`};
  margin-right: 0.5em;
  border-radius: 5px;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledCheckmarkIcon = styled(CheckmarkStroke)`
  position: absolute;
  top: 45%;
  left: 20%;
  height: 0.9em;
  width: 0.9em;
  transform: translateY(-50%);
  fill: none;

  & .checkmark-stroke {
    stroke: ${({ $theme }: StyledComponentPassedProps) => $theme.checkmarkColor};
    transition: none ${ANIMATION_DURATION}ms linear;
    transition-property: stroke-dashoffset, opacity;

    stroke-width: 0.13em;
    stroke-dasharray: 1.8em;
    stroke-dashoffset: ${({ $checked }: StyledComponentPassedProps) => ($checked ? '0em' : '1.8em')};
    opacity: ${({ $checked }: StyledComponentPassedProps) => ($checked ? 1 : 0.6)};
  }
`;

type PropsType = {
  checked: boolean;
  onCheckChange?: (...params: unknown) => unknown;
  children: Node;
  theme?: CheckboxThemeType;
  className?: string;
  isDisabled?: boolean;
};

const Checkbox = ({
  checked,
  onCheckChange = () => {},
  children,
  theme = defaultTheme,
  className,
  isDisabled,
}: PropsType) => {
  return (
    <Wrapper className={className} onClick={onCheckChange} $isDisabled={isDisabled}>
      <StyledCheckbox $theme={theme}>
        <StyledCheckmarkIcon $theme={theme} $checked={checked} />
      </StyledCheckbox>
      {children}
    </Wrapper>
  );
};

export default Checkbox;
